import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useDashboardTheme, cardSx, panelHeaderSx, countBadgeSx, tableHeadRowSx, tableRowSx, scrollbarSx } from '../utils';

function LiveLeaderboard({ liveState, loading }) {
  const t = useDashboardTheme();
  const leaderboard = liveState?.leaderboard || [];
  const bossUserId = liveState?.boss?.userId;

  return (
    <Card sx={cardSx}>
      <MDBox sx={panelHeaderSx(t)}>
        <MDTypography variant='h6' fontWeight='bold' sx={{ letterSpacing: '-0.01em', fontSize: '0.95rem', color: t.primaryText }}>
          Live Leaderboard
        </MDTypography>
        {leaderboard.length > 0 && (
          <MDBox sx={countBadgeSx(t)}>
            <MDTypography variant='caption' fontWeight='bold' sx={{ fontSize: '0.65rem', color: t.tableHeaderColor, letterSpacing: '0.04em' }}>
              {leaderboard.length} player{leaderboard.length !== 1 ? 's' : ''}
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
      {loading && !liveState ? (
        <MDBox sx={{ p: { xs: 2, sm: 3 } }}>
          <Skeleton variant='rectangular' height={120} sx={{ borderRadius: '8px' }} />
        </MDBox>
      ) : leaderboard.length === 0 ? (
        <MDBox display='flex' flexDirection='column' alignItems='center' justifyContent='center' py={4} gap={1}>
          <MDTypography variant='body2' color='text' sx={{ opacity: 0.45 }}>No players on leaderboard</MDTypography>
        </MDBox>
      ) : (
        <TableContainer sx={scrollbarSx(t)}>
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow sx={tableHeadRowSx(t)}>
                <TableCell sx={{ width: 28, pr: 0 }}>#</TableCell>
                <TableCell>Player</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaderboard.map((entry, i) => {
                const isBoss = entry.userId === bossUserId;
                const isTop = i === 0;
                return (
                  <TableRow key={entry.userId} sx={tableRowSx(t, { index: i, isTop })}>
                    <TableCell sx={{ width: 28, pr: 0 }}>
                      <MDTypography variant='caption' sx={{ fontSize: '0.65rem', color: isTop ? t.rankTopColor : t.rankColor, fontWeight: isTop ? 700 : 400 }}>
                        {i + 1}
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography variant='caption' fontWeight={isTop ? 'bold' : 'medium'} sx={{ fontSize: '0.78rem', color: isBoss ? '#fbbf24' : t.primaryText }}>
                        {entry.displayName}
                        {isBoss && (
                          <Chip label='BOSS' size='small' color='warning' sx={{ ml: 1, height: 18, fontSize: '0.65rem' }} />
                        )}
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <Chip label='Active' size='small' color='success' sx={{ height: 18, fontSize: '0.65rem' }} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}

export default LiveLeaderboard;
